<template>
  <NuxtLayout>
    <Transition name="page" mode="out-in" @before-enter="onBeforeEnter">
      <div :key="$route.fullPath">
        <NuxtPage />
      </div>
    </Transition>
  </NuxtLayout>
</template>

<script setup lang="ts">
const { finalizePendingLocaleChange, locale } = useI18n();

const onBeforeEnter = async (): Promise<void> => {
  await finalizePendingLocaleChange();
};

usePageTitle();

useHead({
  htmlAttrs: {
    lang: locale.value,
  },
});
</script>
